<template>
  <el-dialog
    :visible.sync="dialogvisible"
    :title="messageData[0].Title"
    width="700px"
    class="dialog-wrap form-module"
    :close-on-press-escape="false"
    :show-close="false"
    :center="true"
    :close-on-click-modal="false"
    :destroy-on-close="true"
  >
    <!-- <div style="padding-left: 0.625rem; padding-top: 0.9375rem;" class="content_wrap">
          <div class="contentDetail"   v-html="HTMLDecode(messageData.Content)" ></div>
        <div style="padding-top: 1rem;text-align:center">

        </div>
      </div> -->
    <div class="content">
      <div class="content_wrap">
        <div class="contentDetail" v-html="HTMLDecode(messageData[0].Content)"></div>
      </div>
      <div style="text-align: center">
        <el-button @click="fnConfirm()" type="primary">{{ confirmtitle }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    messageData: {
      type: Array
    },
    dialogvisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      confirmtitle: ''
    }
  },
  watch: {
    dialogvisible: function (newVal, oldVal) {
      if (newVal == true) {
        if (this.messageData.length > 1) {
          this.confirmtitle = '我已知悉，确认(还有' + Number(this.messageData.length - 1) + '条未读)'
        } else {
          this.confirmtitle = '我已知悉，确认'
        }
      }
    }
  },
  mounted() {},
  methods: {
    fnConfirm() {
      let config = {
        params: {
          id: this.messageData[0].MessageId
        }
      }
      this.getRequest('SupplierLogin/SupplierNoticeRead', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            if (this.messageData.length == 1) {
              this.$emit('update:dialogvisible', false)
            } else {
              this.messageData.shift()
              if (Number(this.messageData.length) > 1) {
                this.confirmtitle = '我已知悉，确认(还有' + Number(this.messageData.length - 1) + '条未读)'
              } else {
                this.confirmtitle = '我已知悉，确认'
              }
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  border-top: 1px solid #ccc;
  padding-top: 35px;
  padding-bottom: 35px;

  .title {
    color: #0774c5;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  .date {
    text-align: center;
    margin: 10px 0 55px;
    color: #999;
  }

  .content_wrap {
    line-height: 25px;
    width: 95%;
    margin: 0 auto;
    word-break: break-word;

    .img {
      text-align: center;
      margin: 30px 0;

      img {
        max-width: 800px;
      }
    }

    .attach {
      .attach_list {
        color: #0066ff;
        cursor: pointer;
      }
    }
  }
}
</style>